import React, { useState, useEffect, useContext } from 'react';
import deleteicon from '../../../assets/UserProfile/delete_icn_circle.svg';
import add_icn_circle from '../../../assets/UserProfile/add_icn_circle.svg';
import panImage from '../../../assets/UserProfile/pan-img.png';
import { Formerror } from '../../../components/formerror';
import validator from 'validator';
import { useGlobalSpinnerActionsContext } from '../../../components/loader/useloader';
import { Context } from '../../../services/apiContext';
import { useNotificationActionsContext } from '../../../components/notificationModal/useModal';
import InfoLogo from '../../../components/Info';
import { getClientIp } from '../../../helperFunctions/helperFunctions';

const BasicInformation = ({
  nextStep,
  basicDetails,
  nextStepRef,
  handleFormData,
  handleValidity,
  isfromDashBoard,
  isfromCSC,
}) => {
  useEffect(() => {
    nextStepRef.current = () => validateBasicInfo(isfromDashBoard);
    // verifyUser()
    // console.log(basicDetails);

    setProfile(basicDetails);
  });

  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [errors, setErrors] = useState({ valid: false });
  const [hidden, setHidden] = useState(false);
  const contextapi = useContext(Context);
  const setNotifi = useNotificationActionsContext();
  const [profile, setProfile] = useState({
    name: '',
    email: '',
    mobile: '',
    pan: '',
    upi: '',
    isTermsChecked: isfromDashBoard === true ? true : false,
    upiList: [],
  });
  const handleOnProfileChange = (e) => {
    const { name, value } = e.target;
    setProfile({ ...profile, [name]: value });
    handleFormData(name, value);
    if (name !== 'pan') {
      setBasicInfoErrors({ ...basicInfoErrors, [name]: '' });
    }
  };
  const handleOnProfileTerms = (e) => {
    const { name, value } = e.target;
    setProfile({ ...profile, [name]: e.currentTarget.checked });
    handleFormData(name, e.currentTarget.checked);
    setBasicInfoErrors({ ...basicInfoErrors, [name]: '' });
  };
  const [basicInfoErrors, setBasicInfoErrors] = useState({});
  const checkErrors = async (data) => {
    const errorsForm = {};
    if (data.name.trim() === '') {
      errorsForm.name = 'Name is required';
    }
    if (data.email.trim() === '') {
      errorsForm.email = 'Email is required';
    }
    if (data.email.trim() !== '' && !validator.isEmail(data.email.trim())) {
      errorsForm.email = 'Email is Invalid';
    }
    if (
      data.name.trim() !== '' &&
      !validator.matches(data.name, '[a-zA-Z][a-zA-Z ]+[a-zA-Z]$')
    ) {
      errorsForm.name = 'Name is Invalid';
    }
    if (data.name.trim() !== '' && data.name.length > 120) {
      errorsForm.name = 'Name should be less tha 120 charcters';
    }
    if (data.email.trim() !== '' && data.email.length > 120) {
      errorsForm.name = 'Email should be less tha 120 charcters';
    }
    if (data.pan.trim() === '') {
      errorsForm.pan = 'PAN is required';
    }
    if (data.isTermsChecked !== true) {
      errorsForm.isTermsChecked =
        'Please accept Terms and Conditions to proceed';
    }

    return errorsForm;
  };
  const checkPanError = async (data) => {
    if (
      data.pan.trim() !== '' &&
      !validator.matches(data.pan, '/[A-Z]{3}[P]{1}[A-Z]{1}[d]{4}[A-Z]{1}/')
    ) {
      setBasicInfoErrors({
        ...basicInfoErrors,
        pan: 'Invalid PAN ',
        PanVerifed: false,
      });
    } else {
      setBasicInfoErrors({
        ...basicInfoErrors,
        pan: ' ',
        PanVerifed: false,
      });
    }
  };
  const validateBasicInfo = async (isfromDashBoardparam) => {
    setGlobalSpinner(true);
    const error = await checkErrors(profile);
    if (Object.keys(error).length > 0) {
      await setBasicInfoErrors(error);
      setGlobalSpinner(false);
    } else {
      updateUserForm(isfromDashBoardparam);
    }
  };

  const updateUserForm = async (isfromDashBoardparam) => {
    if (isfromDashBoardparam) {
      var useData = contextapi.getSession('userData').user_key;
      var postData = {
        user_key: useData,
        pan: basicDetails.pan,
        user_ip: await getClientIp(),
        email: basicDetails.email,
        upi_id: basicDetails.upiList[0] ? basicDetails.upiList[0] : '',
        upi_id2: basicDetails.upiList[1] ? basicDetails.upiList[1] : '',
        upi_id3: basicDetails.upiList[2] ? basicDetails.upiList[2] : '',
        upi_id4: basicDetails.upiList[3] ? basicDetails.upiList[3] : '',
        upi_id5: basicDetails.upiList[4] ? basicDetails.upiList[4] : '',
      };
      console.log(postData);
      var url = '/user/updateupiemail';
      await contextapi
        .postApiAuthCalling(url, postData, true)
        .then((res) => {
          console.log(res);
          if (res[0].status_code === '00') {
            setGlobalSpinner(false);
            handleValidity('step1valid');
            nextStep();
          } else {
            setNotifi({ val: true, msg: res[0].status_desc });
          }
        })
        .catch((error) => {
          console.log(error);
          // setNotifi({ val: true, msg: "Something went wrong" });
        });
    } else {
      finalSubmit();
    }
  };
  const finalSubmit = async () => {
    var url = '/userp/profileupdate';
    var useData = contextapi.getSession('userData').user_key;
    var clids = [];
    var user_mandates = [];

    var postData = {
      user_key: useData,
      pan: basicDetails.pan,
      name: basicDetails.name,
      user_ip: await getClientIp(),
      email: basicDetails.email,
      mobile: basicDetails.mobile,
      upi: basicDetails.upiList[0] ? basicDetails.upiList[0] : '',
      upi2: basicDetails.upiList[1] ? basicDetails.upiList[1] : '',
      upi3: basicDetails.upiList[2] ? basicDetails.upiList[2] : '',
      upi4: basicDetails.upiList[3] ? basicDetails.upiList[3] : '',
      upi5: basicDetails.upiList[4] ? basicDetails.upiList[4] : '',
      clids: clids,
      user_mandates: user_mandates,
    };
    console.log(postData);
    await contextapi
      .postApiAuthCalling(url, postData, true)
      .then((res) => {
        console.log(res);
        if (res[0].status_code === '00') {
          setGlobalSpinner(false);
          handleValidity('step1valid');
          var userProfile = contextapi.getSession('userProfile');
          var userProfile2 = contextapi.getSession('userData');
          userProfile.basic_profile = 'Y';
          userProfile2.pan = basicDetails.pan;
          userProfile2.name = basicDetails.name;
          userProfile2.email = basicDetails.email;
          console.log(userProfile);
          contextapi.setSession(userProfile, 'userProfile');
          contextapi.setSession(userProfile2, 'userData');
          nextStep();
        } else {
          setNotifi({ val: true, msg: res[0].status_desc });
        }
      })
      .catch((error) => {
        console.log('Error VerifyUser : ', error);
        // setNotifi({ val: true, msg: "Something went wrong" });
      });
  };
  const alphaOnly = (event) => {
    var regex = '^[a-zA-Z.]+$';
    var key = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    // console.log(key)
    setErrors({
      name: '',
    });
    if (!regex.test(key)) {
      setErrors({
        name: 'Invalid Input',
      });
      event.preventDefault();
      return false;
    }
  };

  const validatePan = (e) => {
    let txt = e.target.value;
    console.log(txt);
    txt = txt.toUpperCase();
    var regex = /[A-Z]{3}[P]{1}[A-Z]{1}[\d]{4}[A-Z]{1}/;

    if (txt.length === 10) {
      if (!regex.test(txt)) {
        setBasicInfoErrors({
          ...basicInfoErrors,
          pan: 'Invalid PAN ',
          PanVerifed: false,
        });
        e.preventDefault();
      } else {
        setBasicInfoErrors({
          ...basicInfoErrors,
          pan: '',
          PanVerifed: true,
        });
      }
    } else {
      setBasicInfoErrors({
        ...basicInfoErrors,
        pan: 'Invalid PAN ',
        PanVerifed: false,
      });
    }
  };

  const [upiIds, setupiIds] = useState([]);
  const validateAndAddUPI = (e) => {
    if (profile.upiList.length < 5) {
      if (profile.upiList.includes(profile.upi.toLocaleLowerCase())) {
        setBasicInfoErrors({
          ...basicInfoErrors,
          upi: 'UPI Already Exists',
        });
      } else {
        if (profile.upi.length < 50) {
          let txt = profile.upi;
          var regex = /[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}$/;
          if (regex.test(txt)) {
            console.log('entered');

            // validateUPI();
            let profileLo = basicDetails.upiList;

            profileLo.unshift(txt);
            handleFormData('upiList', profileLo);
            setBasicInfoErrors({
              ...basicInfoErrors,
              upi: '',
            });
            setProfile({ ...profile, upi: '' });
            handleFormData('upi', '');
            // setProfile(profile);
            console.log(basicDetails.upiList);
          } else {
            setBasicInfoErrors({
              ...basicInfoErrors,
              upi: 'Invalid UPI',
            });
          }
        } else {
          setBasicInfoErrors({
            ...basicInfoErrors,
            upi: 'UPI can be max 50 character',
          });
        }
      }
    } else {
      setBasicInfoErrors({
        ...basicInfoErrors,
        upi: 'Only 5 UPI can added',
      });
    }
  };

  const validateUPI = (upiID) => {
    return null;
  };
  const deleteupi = (inx) => {
    let profileLo = basicDetails.upiList.filter((item) => item !== inx);
    handleFormData('upiList', profileLo);
  };
  return (
    <div className='row'>
      <div className='col-lg-9 col-md-12 col-ms-12 paddingZero row'>
        <div className='col-lg-5 col-md-6 col-ms-12 '>
          <div className='form-floating '>
            <input
              type='text'
              className='form-control'
              id='txtName'
              placeholder='Name as per PAN*'
              name='name'
              onChange={handleOnProfileChange}
              required
              autoComplete='off'
              disabled={isfromDashBoard}
              readOnly={isfromDashBoard}
              value={profile.name}
              maxLength={120}
            />
            <label htmlFor='txtName'>
              Name as per PAN
              <span className='txt-red'>*</span>
            </label>
            <Formerror error={basicInfoErrors.name} />
          </div>
        </div>
        <div className='col-lg-5 col-md-4 col-ms-10 '>
          <div className='form-floating'>
            <input
              type='text'
              className={`form-control  PANtext ${
                basicInfoErrors.PanVerifed === true ? 'PanVerified' : ''
              }`}
              id='Pan'
              placeholder='PAN*'
              name='pan'
              required
              disabled={isfromDashBoard}
              readOnly={isfromDashBoard}
              value={profile.pan}
              autoComplete='off'
              onChange={handleOnProfileChange}
              onInput={validatePan}
              maxLength={10}
            />
            <label htmlFor='Pan'>
              PAN<span className='txt-red'>*</span>
            </label>
            <Formerror error={basicInfoErrors.pan} />
          </div>
        </div>
        <div className='col-lg-2 col-md-2 col-ms-2 relativ'>
          {basicInfoErrors.PanVerifed === true && (
            <span className='pan-msg'>PAN details are valid </span>
          )}
        </div>
        <div className='col-lg-5 col-md-6 col-ms-12 '>
          <div className='form-floating emailonhover'>
            <input
              type='text'
              className='form-control '
              // className={(errors.email === '' && profile.email.length>1) ? ("form-control successborder"): ( (errors.email === '')? "form-control " : 'form-control errorborder')}
              id='txtEmail'
              placeholder='Email'
              name='email'
              value={profile.email}
              required
              autoComplete='off'
              onChange={(e) => {
                handleOnProfileChange(e);
              }}
              maxLength={120}
            />
            <label htmlFor='txtEmail'>
              Email<span className='txt-red'>*</span>
            </label>
            <Formerror error={basicInfoErrors.email} />
            <div className='inforinemail'>
              <InfoLogo />
              <div className='innerInfo'>
                <div className='inner_innerInfo'>
                  <p>Enter an email id to receive future communication</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-lg-5 col-md-6 col-ms-12 '>
          <div className='form-floating '>
            <input
              type='tel'
              className='form-control '
              id='txtMobile'
              value={profile.mobile}
              placeholder='Mobile'
              readOnly
              autoComplete='off'
              disabled
              name='mobile'
              onChange={handleOnProfileChange}
              // readOnly
            />
            <label htmlFor='txtMobile'>
              Mobile <span className='txt-red'>*</span>
            </label>
            <Formerror error={basicInfoErrors.mobile} />
          </div>
        </div>

        {hidden && (
          <div className='col-lg-10 col-md-12 col-ms-12 '>
            <div className='form-floating mb-0 '>
              <div className='makeINPUTINSIDE'>
                <div className='form-floating make100'>
                  <input
                    type='text'
                    className='form-control successborder'
                    id='upiinput'
                    placeholder='test@okicici'
                    name='upi'
                    maxLength={50}
                    autoComplete='off'
                    value={profile.upi}
                    onChange={handleOnProfileChange}
                    required
                  />
                  <label htmlFor='upiinput'>Enter UPI Id</label>
                  <Formerror error={basicInfoErrors.upi} />
                </div>

                <div className='makeINPUTINSIDE_child'>
                  <img
                    src={add_icn_circle}
                    alt=''
                    title=''
                    className='input-action-icn-inner'
                    onClick={(e) => validateAndAddUPI(e)}
                  />
                </div>
              </div>
              {/* <div>
           <img src={upiverified} alt='upiverified' className="upiverifyImg" />
           <img src={plusAdd} alt='upiadd' className="upiAddImg" />
           </div> */}

              {/* <label htmlFor="txtMobile">
           Mobile <span className="txt-red">*</span>
       </label> */}
            </div>
          </div>
        )}

        {hidden &&
          basicDetails.upiList.length >= 1 &&
          basicDetails.upiList.map((e, i) => (
            <div className='col-lg-10 col-md-12 col-ms-12' key={i}>
              <div className='form-floating mb-0'>
                <div className='makeINPUTINSIDE'>
                  <div className='form-floating make100 addborder'>
                    <p>{e}</p>
                    {/* <input
                 type="text"
                 className="form-control "
                 id="upiinput2"
                 name="upi2"
                 onChange={handleOnProfileChange}
                 readOnly
             /> */}
                  </div>
                  <div className='makeINPUTINSIDE_child'>
                    <img
                      src={deleteicon}
                      alt=''
                      title=''
                      className='input-action-icn-inner cursoPointer'
                      onClick={() => deleteupi(e)}
                    />
                  </div>
                </div>

                <p className='text-danger m-2'>{errors.upi2Err}</p>
              </div>
            </div>
          ))}

        <div className='col-lg-10 col-sm-12 textCenter'>
          <div className='form-check mb-4 p-0 d-flex justify-content-start'>
            <input
              className='m-1'
              type='checkbox'
              name='isTermsChecked'
              disabled={isfromDashBoard}
              readOnly={isfromDashBoard}
              checked={isfromDashBoard ? true : profile.isTermsChecked}
              onChange={handleOnProfileTerms}
              id='flexCheckDefault'
            />
            <label
              className=' fssmall textleftalign'
              htmlFor='flexCheckDefault'
            >
              {/* I provide my consent to KFintech to share my personal information collected and
              it can be exchanged with broking houses for Demat account opening
              and the same shall be considered by  Kfintech and its
              associates to communicate in the form of SMS, Email, or
              Whatsapp and this shall override the "do not disturb" services
              opted with the telephone operators. */}
              I hereby provide my consent to KFin Technologies Private Limited
              (“KFintech”) through this platform to share my personal
              information with the Broking House as selected by me for opening
              of demat and trading account. In case there is any failure or
              downtime in the process of opening of the account, then KFintech
              (including it’s associates and business partners) shall
              communicate the same via Email, SMS or Whatsapp, and further
              assist in completing the process. The communication sent via
              EMail, SMS or Whatsapp shall be delivered to me overriding the Do
              Not Disturb (“DND”) services opted by me (if any) with the
              concerned telephone operators. I hereby allow KFintech to
              prepopulate the demat and banking Information in the platform if
              available with KFintech as a Registrar and Transfer Agent. I
              permit the broking house to share my DP Id and Client ID in
              response to KFintech once my account is activated
            </label>
          </div>
          <Formerror error={basicInfoErrors.isTermsChecked} />
        </div>
        <div className='col-lg-12 col-sm-12 textCenter'>
          <button
            type='button'
            name='button'
            className='makewhitcolor btnInuse btn-default makewhitcolor'
            onClick={() => validateBasicInfo(isfromDashBoard)}
          >
            Save and Continue
          </button>
        </div>
      </div>
      <div className='col-lg-3 col-md-12 col-ms-12 paddingZero'>
        {!isfromCSC && (
          <div className='apply-pan-box'>
            <img src={panImage} alt='panImage' className='panImage' />
            <a
              target='_blank'
              href=' https://www.onlineservices.nsdl.com/paam/endUserRegisterContact.html'
            >
              <button
                type='button'
                name='button'
                className=' btnInuse  btn-secondaryCustom impocolor'
              >
                Apply PAN Now
              </button>
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default BasicInformation;
